import { Link } from "@tanstack/react-router";
import { useState } from "react";
import logoAsset from "@/assets/elektriker-logo.webp.asset.json";

const nav = [
  { to: "/", label: "Forside" },
  { to: "/ydelser", label: "Ydelser" },
  { to: "/priser-erhverv", label: "Priser" },
  { to: "/byer", label: "Byer" },
  { to: "/om-os", label: "Om os" },
  { to: "/blog", label: "Blog" },
  { to: "/kontakt", label: "Kontakt" },
];

export function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 w-full border-b border-border/60 bg-background/85 backdrop-blur supports-[backdrop-filter]:bg-background/70">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link to="/" className="flex items-center gap-2" aria-label="Elektriker-Elektriker forside">
          <img
            src={logoAsset.url}
            alt="Elektriker-Elektriker logo"
            width={180}
            height={36}
            className="h-9 w-auto"
            loading="eager"
          />
        </Link>

        <Link
          to="/tekniq-garanti"
          title="TEKNIQ-garanti dækker op til 150.000 kr. ved fejl og mangler"
          className="hidden items-center gap-1.5 rounded-full border border-border/80 bg-secondary/60 px-3 py-1 text-[11px] font-semibold text-[var(--ink)] backdrop-blur-sm transition hover:border-primary/50 hover:bg-secondary sm:flex"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-primary">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
          Medlem af Tekniq garantiordning
        </Link>

        <nav className="hidden items-center gap-7 md:flex" aria-label="Hovednavigation">
          {nav.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              className="text-sm font-medium text-[var(--ink)] transition-colors hover:text-[var(--ink)]"
              activeProps={{ className: "text-[var(--ink)] font-semibold" }}
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="tel:+4528700028"
            className="text-sm font-semibold text-[var(--ink)] hover:text-primary"
          >
            +45 28 7000 28
          </a>
          <Link
            to="/tilbud"
            className="inline-flex h-10 items-center justify-center rounded-md bg-primary px-4 text-sm font-semibold text-primary-foreground shadow-sm transition hover:brightness-95"
          >
            Indhent tilbud
          </Link>
        </div>

        <button
          aria-label="Åbn menu"
          aria-expanded={open}
          className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-border md:hidden"
          onClick={() => setOpen((v) => !v)}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            {open ? <path d="M6 6l12 12M6 18L18 6" /> : <path d="M3 6h18M3 12h18M3 18h18" />}
          </svg>
        </button>
      </div>

      {open && (
        <div className="border-t border-border bg-background md:hidden">
          <div className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-3">
            {nav.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2 text-sm font-medium text-[var(--ink)] hover:bg-secondary"
              >
                {n.label}
              </Link>
            ))}
            <a href="tel:+4528700028" className="rounded-md px-3 py-2 text-sm font-semibold text-primary">
              Ring: +45 28 7000 28
            </a>
            <Link
              to="/tilbud"
              onClick={() => setOpen(false)}
              className="mt-1 inline-flex h-11 items-center justify-center rounded-md bg-primary px-4 text-sm font-semibold text-primary-foreground"
            >
              Indhent tilbud
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
